export default class TextCta {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
